import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./professionalTheme.css";
import App from "./App";
import DialogProvider from "./components/DialogProvider";
import NativeExamFlowDemo from "./teacher/exams/NativeExamFlowDemo";
import { installerPleinEcranVideo } from "./services/pleinEcranVideo";
import { installerSonAlerte } from "./services/sonAlerte";
import { installerPreferences } from "./services/preferences";

// Supprime l'avertissement bénin ResizeObserver (MathLive / Chart.js)
// window.onerror s'exécute avant les listeners React Dev Server
const _origOnError = window.onerror;
window.onerror = function (msg, src, line, col, err) {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) return true;
  return _origOnError?.apply(this, arguments);
};
// Double protection via addEventListener au cas où
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true); // capture phase = avant tous les autres listeners

// Vidéos : plein écran sur téléphone, même là où le navigateur le refuse au lecteur intégré.
installerPleinEcranVideo();
installerSonAlerte();
installerPreferences();  // langue et mode nuit choisis dans « Paramètres »

const root = ReactDOM.createRoot(document.getElementById("root"));
const showNativeExamDemo = process.env.NODE_ENV !== "production"
  && process.env.REACT_APP_NATIVE_EXAM_FLOW_DEMO === "true";
root.render(
  <>
    {showNativeExamDemo ? <NativeExamFlowDemo /> : <App />}
    <DialogProvider />
  </>
);
